import React, { useEffect, useState } from 'react';
import Button from '@sabre/spark-react-core/button';
import Icon from '@sabre/spark-react-core/icon';
import TextInput from '@sabre/spark-react-core/text-input';
import { func, array, bool, string } from 'prop-types';
import { CSVLink, CSVDownload } from 'react-csv';
import useApi from '../../../api-wrapper/use-api.js';
import { URL_LOAD_TIME } from '../../../end-points.js';
import { TOOL_BAR_BUTTONS } from '../../../utils/constants.js';
import { DateUtil } from '../../../utils/date-util.js';

const ToolBar = ({
   data,
   title,
   isDisable,
   totalItems,
   handleQueryNameSave,
   handleOpenStoredCriteriaModal,
   handleSetSelectedTabChange,
   handleNotification,
   handlegetLoadTime,
   isCompleteAllData,
   isDistributionLinkClick,
   selectedScreen,
   handleUploadDistributionDocumentButtonClick,
}) => {
   const [toolBarConfig, setToolBarConfig] = useState({
      queryName: '',
      toolbarTabs: [],
      atpcoDate: '',
   });
   const [csvData, setCsvData] = useState([]);
   const [loadTime, setLoadTime] = useApi({});
   const [firstApiCallMinutes, setFirstApiCallMinutes] = useState({
      time: undefined,
      minute: undefined,
   });
   const intervalKeys = ['tenMinutesTimeInterval', 'oneMinutesTimeInterval'];
   const timeoutKeys = ['defaultTimeOut', 'twentyFiveMinuteTimeOut'];
   const handleQueryNameTextChange = (value) => {
      setToolBarConfig({
         ...toolBarConfig,
         queryName: value.toUpperCase(),
      });
   };
   const handleQueryNameSaveButtonClick = () => {
      handleQueryNameSave(toolBarConfig);
   };
   const handleTabChange = (item) => {
      const result = toolBarConfig.toolbarTabs.map((list) => {
         list.isSelect = list.KEY === item.KEY ? true : false;
         return list;
      });
      setToolBarConfig({
         ...toolBarConfig,
         toolbarTabs: result,
         queryName: '',
      });
      intervalKeys.forEach((key) => clearInterval(key));
      timeoutKeys.forEach((key) => clearTimeout(key));
      if (item.KEY === 'Fares') {
         loadTimeApi();
         currentTimeSet();
      }
      handleSetSelectedTabChange(item.KEY, false);
   };
   const handleDownloadClick = () => {
      setCsvData(data);
   };
   const notifications = () => {
      handleNotification();
   };
   const loadTimeApi = () => {
      setLoadTime({ method: 'GET', url: URL_LOAD_TIME });
   };
   const currentTimeSet = () => {
      const date = new Date();
      setFirstApiCallMinutes({
         time: date.getTime(),
         minute: date.getMinutes(),
      });
   };
   useEffect(() => {
      if (!Array.isArray(loadTime.data)) {
         const dateTime = DateUtil.formatDate(
            DateUtil.estTime(loadTime.data),
            DateUtil.DATE_FORMATS.DD_MMM_YY_TIME
         ).toUpperCase();
         setToolBarConfig({
            ...toolBarConfig,
            atpcoDate: dateTime,
         });
         handlegetLoadTime(loadTime.data);
      }
   }, [loadTime.isLoading]);
   useEffect(() => {
      if (selectedScreen === 'Fares') {
         loadTimeApi();
         currentTimeSet();
      }
      TOOL_BAR_BUTTONS.map(
         (list, index) => (list.isSelect = index === 0 ? true : false)
      );
      setToolBarConfig({
         ...toolBarConfig,
         toolbarTabs: TOOL_BAR_BUTTONS,
      });
   }, []);
   useEffect(() => {
      if (firstApiCallMinutes.minute || firstApiCallMinutes.minute === 0) {
         let tenMinutesTimeInterval = undefined;
         let oneMinutesTimeInterval = undefined;
         let defaultTimeOut = undefined;
         let twentyFiveMinuteTimeOut = undefined;
         clearInterval(tenMinutesTimeInterval);
         clearInterval(oneMinutesTimeInterval);
         clearTimeout(defaultTimeOut);
         clearTimeout(twentyFiveMinuteTimeOut);
         const currentBalanceMinutes =
            60 - firstApiCallMinutes.minute === 0
               ? 60
               : 60 - firstApiCallMinutes.minute;
         if (currentBalanceMinutes >= 25) {
            // This will call balance time more than 25 minutes
            twentyFiveMinuteTimeOut = setTimeout(() => {
               loadTimeApi();
               clearInterval(tenMinutesTimeInterval);
               clearInterval(oneMinutesTimeInterval);
               tenMinutesTimeInterval = setInterval(() => {
                  // 10 mins api call;
                  loadTimeApi();
               }, 60000 * 10);
            }, 60000 * 25);
         }
         setTimeout(() => {
            // 5 mins api call;
            loadTimeApi();
            oneMinutesTimeInterval = setInterval(() => {
               // 1 mins api call;
               loadTimeApi();
            }, 60000);
         }, 60000 * 5);

         defaultTimeOut = setTimeout(() => {
            // This will call every rounder one hours in system time
            clearInterval(tenMinutesTimeInterval);
            clearInterval(oneMinutesTimeInterval);
            // 60 or balance time  mins api call ;
            loadTimeApi();
            const date = new Date();
            setFirstApiCallMinutes({
               time: date.getTime(),
               minute: date.getMinutes(),
            });
         }, 60000 * currentBalanceMinutes);
      }
   }, [firstApiCallMinutes]);

   useEffect(() => {
      const toolBarTabs = TOOL_BAR_BUTTONS.map((tab) => {
         const isTabSelected = tab.KEY === selectedScreen ? true : false;
         tab.isSelect = isTabSelected;
         return tab;
      });
      setToolBarConfig({
         ...toolBarConfig,
         queryName: title,
         toolbarTabs: toolBarTabs,
      });
   }, [title]);

   useEffect(() => {
      if (isDistributionLinkClick) {
         TOOL_BAR_BUTTONS.map(
            (list) => (list.isSelect = list.KEY === 'Reference' ? true : false)
         );
         setToolBarConfig({
            ...toolBarConfig,
            toolbarTabs: TOOL_BAR_BUTTONS,
            queryName: '',
         });
      }
   }, [isDistributionLinkClick]);
   const screensWithoutIcons = ['Footnotes', 'Rules'];
   const isShowIcons = !screensWithoutIcons.includes(selectedScreen);
   return (
      <div className='row tool-bar-root'>
         <div className='col-md-2 col-lg-2 spark-flex spark-pad-0 tool-bar-left'>
            <div className='col-md-2 col-lg-2 tool-bar-left-expand-icon spark-pad-t-.5 spark-pad-b-.5'>
               <Icon
                  name='resize-max'
                  size='md'
                  style='fill'
                  label='stored-criteria-open'
                  onClick={() => handleOpenStoredCriteriaModal()}
               />
            </div>
            <div className='col-md-8 col-lg-8 empty-padding'>
               <TextInput
                  data-testid='query-name-text'
                  className='query-input'
                  name='queryNameText'
                  autoComplete='off'
                  value={toolBarConfig.queryName}
                  onChange={(event, selectedValue) =>
                     handleQueryNameTextChange(selectedValue)
                  }
               />
            </div>
            <div className='col-md-2 col-lg-2  tool-bar-left-expand-icon spark-pad-t-.5 spark-pad-b-.5 tool-bar-left-save-icon'>
               <Icon
                  name='save'
                  size='md'
                  className='spark-success'
                  style='fill'
                  onClick={handleQueryNameSaveButtonClick}
                  label='query-name-save'
               />
            </div>
         </div>
         <div className='row col-md-7 col-lg-7 tool-bar-right spark-align-items-center'>
            {toolBarConfig.toolbarTabs.length > 0 &&
               toolBarConfig.toolbarTabs.map((item, index, data) => {
                  return (
                     <Button
                        title={item.KEY}
                        name={item.KEY}
                        label={item.KEY}
                        className={` ${
                           !item.isSelect
                              ? 'spark-btn-group-secondary tool-bar-right-un-selected'
                              : 'spark-btn-group-primary tool-bar-right-selected'
                        } ${
                           index === 0
                              ? 'left-border'
                              : index === data.length - 1
                              ? 'right-border'
                              : 'default-no-border'
                        }  search-criteria-footer-button spark-btn-over-ride`}
                        secondary={!item.isSelect ? true : false}
                        key={index}
                        size='xs'
                        onClick={() => handleTabChange(item)}
                     >
                        {item.KEY}
                     </Button>
                  );
               })}
         </div>
         {isShowIcons && (
            <div
               className={`${
                  selectedScreen === 'Fares'
                     ? 'col-md-3 col-lg-3  download-layout'
                     : 'col-md-1 col-lg-1 download-dg-layout'
               } row`}
            >
               <>
                  {selectedScreen === 'Fares' ? (
                     <div
                        className='download-layout-label'
                        label='last-atpco-sub'
                     >{`Last ATPCO Sub : ${toolBarConfig.atpcoDate}`}</div>
                  ) : (
                     <>
                        <Icon
                           name='file-upload'
                           size='md'
                           className='download-dg-layout-icon'
                           style='fill'
                           onClick={handleUploadDistributionDocumentButtonClick}
                           label='dg-log-upload'
                        />
                     </>
                  )}
                  {!isDisable && (
                     <div className='download-layout-icon'>
                        {isCompleteAllData ? (
                           <CSVLink
                              filename='Export fares details'
                              data={csvData}
                              onClick={() => handleDownloadClick()}
                           >
                              <Icon
                                 name='file-download'
                                 size='md'
                                 style='fill'
                                 label='Download'
                              />
                           </CSVLink>
                        ) : (
                           <Icon
                              name='file-download'
                              size='md'
                              onClick={() => notifications()}
                              style='fill'
                              label='Download'
                           />
                        )}
                     </div>
                  )}
               </>
            </div>
         )}
      </div>
   );
};

ToolBar.propTypes = {
   isDisable: bool,
   title: string,
   data: array,
   totalItems: string,
   selectedScreen: string,
   isCompleteAllData: bool,
   isDistributionLinkClick: bool,
   handleQueryNameSave: func,
   handleOpenStoredCriteriaModal: func,
   handleUploadDistributionDocumentButtonClick: func,
   handleSetSelectedTabChange: func,
   handleNotification: func,
   handlegetLoadTime: func,
};
export default ToolBar;
